import React from "react";
import Logo from "./loading.gif";
import styles from "./LoadingLogo.module.scss";

const LoadingLogo = () => (
  <div>
    <div className={styles.loadingLogo}>
      <img src={Logo} alt="Loading..." />
    </div>
  </div>
);

export default LoadingLogo;
